import Vue from 'vue'
import VueRouter from 'vue-router'
import settingsRoutes from './settings/'
import gekkoRoutes from './gekko/'
import accountantsRoutes from './accountants'
import store from '../store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? './' : './', //process.env.BASE_URL
  routes: [
    ...settingsRoutes,
    ...gekkoRoutes,
    ...accountantsRoutes
  ]
})

// auth navigation guard
router.beforeEach((to, from, next) => {
  // console.log('router::beforeEach() -> ## NAVIGATION GUARD ##', to.name)

  if (to.name === 'Logout') {
    const language = to.params.language || 'en'
    store.dispatch('auth/logout', language)
    return
  }
  
  if (!store.getters['auth/getAuthenticated']) {
    tryAuthenticate(to, from, next)
  } else {
    loadRoute(to, from, next)
  }
})

function tryAuthenticate (to, from, next) {
  // console.log('router::tryAuthenticate() -> App not yet authenticated, trying to get localStorage access_token')

  // if access_token on url params -> set to LocalStorage, call auth/urlLogin, then checkAuth
  // ?access_token=YGsFeUyKzYNqK1vRRqOKnXIb1accHH&refresh_token=0JkC2LOJOozopg7O7Ntjj2oiyPH1t0&company_id=22&user_id=2&platform=web&next=something
  if (['access_token', 'refresh_token', 'user_id', 'company_id'].every(key => to.query[key])) {
    const authData = {
      access_token: to.query.access_token,
      refresh_token: to.query.refresh_token,
      user_id: to.query.user_id,
      company: to.query.company_id
    };

    // platform: [web, costs, hours, trips, invoices, full ]
    if (to.query.platform && to.query.platform !== 'web') {
      authData.mobile_app_view = true
    }    
    store.dispatch('auth/urlLogin', authData).then(() => {
      store.dispatch('auth/checkAuth').then(() => {
        if (to.query.next) {
          const nextUrl = to.query.next
          // console.log('to.query.next', nextUrl)
          if (nextUrl.startsWith('http://') || nextUrl.startsWith('https://')) {
            window.location.href = nextUrl
          } else {
            // next({ path: `${normalizeNextUrl(to)}` })
            window.location.href = `${window.location.protocol}//${window.location.host}${normalizeNextUrl(to)}`
          }
        } else {
          loadRoute(to, from, next)
        }
      })
    })
  } else {
    store.dispatch('auth/checkAuth').then(() => {
      loadRoute(to, from, next)
    })
  }
}

function loadRoute (to, from, next) {
  // console.log('router::loadRoute()')
  const language = to.params.language || 'en'
  if (to.matched.some(record => record.meta.noAuth)) {
    // console.log('router::loadRoute() -> ******** noAuth ********', to)
    if (to.name === 'Login' && store.getters['auth/getAuthenticated']) {
      // console.log('router::loadRoute() -> User already authenticated. Redirect to Dashboard.')
      next({ name: 'Dashboard', params: { language } })
    } else {
      next()
    }
  } else {
    // console.log('router::loadRoute() -> ******** Auth required ********', to)
    if (!store.getters['auth/getAuthenticated']) {
      // console.log('router::loadRoute() -> not authenticated. Redirect to login.')

      const queryParams = Object.entries(to.query).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&')
      const loginUrl = '/accounts/login'
      const redirectUrl = `${loginUrl}?${queryParams}`
      window.location.href = redirectUrl
    } else {
      // console.log('router::loadRoute() -> access granted')
      next()
    }
  }
}
function normalizeNextUrl(to) {
  const nextUrl = to.query.next

  if (!nextUrl) return false

  // Normalize nextUrl to start with '/'
  const normalizedNextUrl = nextUrl.startsWith('/') ? nextUrl : '/' + nextUrl

  // Extract the first segment (language slug) after the leading '/'
  const langSlug = normalizedNextUrl.split('/')[1]  // Get the first segment after the leading '/'

  // If no language code, use the param or default to 'en'
  const language = /^[a-zA-Z]{2}$/.test(langSlug) ? '' : '/' + (to.params.language || 'en')

  // Return the full URL with the language and normalized next URL
  return `${language}${normalizedNextUrl}`
}

export default router
